import React from 'react';
import { ResetPasswordDataContext } from './context';

export const useResetPasswordData = () => React.useContext(ResetPasswordDataContext).resetPasswordData;

export const useSetResetPasswordData = () => React.useContext(ResetPasswordDataContext).setResetPasswordData;
